
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'data-privacy-request-ui',
  currentProjectVersion: 'static-1.5474',
  depVersions: {
  "data-privacy-request-ui": "static-1.5474",
  "data-fetching-client": "static-1.9619",
  "head-dlb": "static-1.4938",
  "hs-test-utils": "static-1.7961",
  "hub-http-shared-msw-handlers": "static-1.9829",
  "hubspot-dlb": "static-2.1832",
  "HubStyleTokens": "static-2.11405",
  "I18n": "static-7.1610",
  "jasmine-runner": "static-1.6415",
  "privacy-center-public-service-types": "static-1.4737",
  "quartz": "static-1.6947",
  "react-dlb": "static-1.77",
  "ui-components-test-utils": "static-1.5543",
  "UIComponents": "static-3.8352",
  "webpack-env": "static-1.54",
  "apollo-stack-hubspot": "static-3.84",
  "foundations-assets": "static-1.4798",
  "foundations-components": "static-1.7816",
  "foundations-components-test-utils": "static-1.5299",
  "foundations-theming": "static-1.4360",
  "hub-http": "static-1.6166",
  "quartz-config": "static-1.725",
  "quartz-core": "static-1.6166",
  "quartz-routing": "static-1.377",
  "quick-fetch": "static-1.3871",
  "raven": "static-3.5829",
  "react": "static-7.184",
  "react-rhumb": "static-1.16609",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11096",
  "usage-tracker": "static-1.7282",
  "usage-tracker-anonymous": "static-1.5699",
  "usage-tracker-core": "static-1.7132",
  "enviro": "static-4.428",
  "hs-promise-rejection-tracking": "static-1.5489",
  "PortalIdParser": "static-2.388",
  "raven-hubspot": "static-1.6136",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4049",
  "immutable": "static-2.77",
  "metrics-js": "static-1.9542",
  "react-redux": "static-7.70",
  "redux": "static-4.16",
  "styled-components": "static-2.88",
  "bend-plugin-trellis-migration": "static-1.3357",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3224",
  "quartz-webpack": "static-1.3171",
  "bend-plugin-quartz-routing": "static-1.25",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.80",
  "HeadJS": "static-2.740",
  "framer-motion": "static-1.70",
  "hs-test-utils-bend-plugin": "static-1.3072",
  "msw": "static-1.39",
  "testing-library": "static-1.150",
  "ts-schema": "static-1.4032",
  "i18n-data": "static-1.220",
  "moment-timezone": "static-5.81",
  "react-utils": "static-2.5298",
  "StyleGuideUI": "static-3.486",
  "jasmine": "static-4.4270",
  "rpc-client-utils": "static-1.4592",
  "HubStyle": "static-2.11713",
  "ui-addon-draggable": "static-3.4715",
  "cssUtils": "static-1.778",
  "hs-story-utils": "static-1.9374",
  "icons": "static-2.643",
  "react-select-plus": "static-1.103",
  "react-virtualized": "static-2.97",
  "ui-images": "static-2.1138",
  "bend-plugin-foundations-components": "static-1.4085",
  "floating-ui": "static-1.54",
  "foundations-theming-specialty": "static-1.2076",
  "react-aria": "static-1.64",
  "react-create-root-preference": "static-1.9",
  "tanstack-table": "static-1.53",
  "trellis-assets": "static-1.1642",
  "ui-fonts": "static-1.667",
  "foundations-components-legacy": "static-1.841",
  "bend-plugin-foundations-theming": "static-1.2843",
  "foundations-theming-base": "static-1.3345",
  "stylex": "static-1.31",
  "hs-locale-management": "static-1.38",
  "dispatcher": "static-1.135",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.826",
  "hubspotter-http": "static-1.4606",
  "mobile-manifest-mixins": "static-1.514",
  "module-federation": "static-1.21",
  "quartz-auth": "static-1.622",
  "quartz-head": "static-1.612",
  "quartz-i18n": "static-1.622",
  "quartz-test": "static-1.622",
  "quartz-tracking": "static-1.326",
  "usage-tracker-container": "static-1.7272",
  "history": "static-4.47",
  "react-router-dom": "static-5.26",
  "csstype": "static-1.50",
  "web-vitals": "static-1.3",
  "react-input-autosize": "static-2.17",
  "bender-build-tools": "static-1.3123",
  "chirp-fetch": "static-1.1831",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.68",
  "sassPrefix": "static-1.154",
  "hubspotter-http-shared-msw-handlers": "static-1.9827",
  "usage-tracker-session-replay": "static-1.4968",
  "amplitude-session-replay-browser": "static-1.58"
},
  depPathPrefixes: {
  "data-privacy-request-ui": "/data-privacy-request-ui/static-1.5474",
  "data-fetching-client": "/data-fetching-client/static-1.9619",
  "head-dlb": "/head-dlb/static-1.4938",
  "hs-test-utils": "/hs-test-utils/static-1.7961",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9829",
  "hubspot-dlb": "/hubspot-dlb/static-2.1832",
  "HubStyleTokens": "/HubStyleTokens/static-2.11405",
  "I18n": "/I18n/static-7.1610",
  "jasmine-runner": "/jasmine-runner/static-1.6415",
  "privacy-center-public-service-types": "/privacy-center-public-service-types/static-1.4737",
  "quartz": "/quartz/static-1.6947",
  "react-dlb": "/react-dlb/static-1.77",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5543",
  "UIComponents": "/UIComponents/static-3.8352",
  "webpack-env": "/webpack-env/static-1.54",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "foundations-assets": "/foundations-assets/static-1.4798",
  "foundations-components": "/foundations-components/static-1.7816",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5299",
  "foundations-theming": "/foundations-theming/static-1.4360",
  "hub-http": "/hub-http/static-1.6166",
  "quartz-config": "/quartz-config/static-1.725",
  "quartz-core": "/quartz-core/static-1.6166",
  "quartz-routing": "/quartz-routing/static-1.377",
  "quick-fetch": "/quick-fetch/static-1.3871",
  "raven": "/raven/static-3.5829",
  "react": "/react/static-7.184",
  "react-rhumb": "/react-rhumb/static-1.16609",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11096",
  "usage-tracker": "/usage-tracker/static-1.7282",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5699",
  "usage-tracker-core": "/usage-tracker-core/static-1.7132",
  "enviro": "/enviro/static-4.428",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
  "PortalIdParser": "/PortalIdParser/static-2.388",
  "raven-hubspot": "/raven-hubspot/static-1.6136",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4049",
  "immutable": "/immutable/static-2.77",
  "metrics-js": "/metrics-js/static-1.9542",
  "react-redux": "/react-redux/static-7.70",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.88",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3357",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3224",
  "quartz-webpack": "/quartz-webpack/static-1.3171",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.25",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.80",
  "HeadJS": "/HeadJS/static-2.740",
  "framer-motion": "/framer-motion/static-1.70",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3072",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.150",
  "ts-schema": "/ts-schema/static-1.4032",
  "i18n-data": "/i18n-data/static-1.220",
  "moment-timezone": "/moment-timezone/static-5.81",
  "react-utils": "/react-utils/static-2.5298",
  "StyleGuideUI": "/StyleGuideUI/static-3.486",
  "jasmine": "/jasmine/static-4.4270",
  "rpc-client-utils": "/rpc-client-utils/static-1.4592",
  "HubStyle": "/HubStyle/static-2.11713",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4715",
  "cssUtils": "/cssUtils/static-1.778",
  "hs-story-utils": "/hs-story-utils/static-1.9374",
  "icons": "/icons/static-2.643",
  "react-select-plus": "/react-select-plus/static-1.103",
  "react-virtualized": "/react-virtualized/static-2.97",
  "ui-images": "/ui-images/static-2.1138",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4085",
  "floating-ui": "/floating-ui/static-1.54",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2076",
  "react-aria": "/react-aria/static-1.64",
  "react-create-root-preference": "/react-create-root-preference/static-1.9",
  "tanstack-table": "/tanstack-table/static-1.53",
  "trellis-assets": "/trellis-assets/static-1.1642",
  "ui-fonts": "/ui-fonts/static-1.667",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.841",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2843",
  "foundations-theming-base": "/foundations-theming-base/static-1.3345",
  "stylex": "/stylex/static-1.31",
  "hs-locale-management": "/hs-locale-management/static-1.38",
  "dispatcher": "/dispatcher/static-1.135",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.826",
  "hubspotter-http": "/hubspotter-http/static-1.4606",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.514",
  "module-federation": "/module-federation/static-1.21",
  "quartz-auth": "/quartz-auth/static-1.622",
  "quartz-head": "/quartz-head/static-1.612",
  "quartz-i18n": "/quartz-i18n/static-1.622",
  "quartz-test": "/quartz-test/static-1.622",
  "quartz-tracking": "/quartz-tracking/static-1.326",
  "usage-tracker-container": "/usage-tracker-container/static-1.7272",
  "history": "/history/static-4.47",
  "react-router-dom": "/react-router-dom/static-5.26",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.3",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "bender-build-tools": "/bender-build-tools/static-1.3123",
  "chirp-fetch": "/chirp-fetch/static-1.1831",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.68",
  "sassPrefix": "/sassPrefix/static-1.154",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9827",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4968",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.58"
}
};
